import { useRef } from 'react';
import { WorkspaceClosureSection } from './WorkspaceClosureSection';
import { WorkspaceExportSection } from './WorkspaceExportSection';

export function DataAndClosureSection() {
  const exportSectionReference = useRef<HTMLDivElement>(null);

  function scrollToExportSection() {
    const exportSectionElement = exportSectionReference.current;
    if (exportSectionElement !== null) {
      exportSectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  return (
    <div className="space-y-6">
      <div ref={exportSectionReference}>
        <WorkspaceExportSection />
      </div>
      <WorkspaceClosureSection onGoToExport={scrollToExportSection} />
    </div>
  );
}
